import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween.js";
dayjs.extend(isBetween);
import { closedDates, type DayStrings, openingHours } from "./opening-hours";

export function getClosedNearDates(skipToday = false, nearDays = 14) {
    // Start today or tomorrow?
    const start = skipToday ? new Date().getTime() + 24 * 60 * 60 * 1000 : new Date();
    const end = dayjs(new Date()).add(nearDays, "day");
    return closedDates.filter((d) => dayjs(d).isBetween(dayjs(start), end, "day", "[]")).map((d) => dayjs(d));
}

export function isClosedToday() {
    return closedDates.filter((d) => dayjs(d).isSame(dayjs(), "day")).map((d) => dayjs(d)).length > 0;
}

export function openingHoursString(joinChar = "<br />") {
    const dayMap: Record<DayStrings, string> = {
        monday: "Måndag",
        tuesday: "Tisdag",
        wednesday: "Onsdag",
        thursday: "Torsdag",
        friday: "Fredag",
        saturday: "Lördag",
    };
    return Object.entries(openingHours)
        .map(([day, hours]) => `${dayMap[day as DayStrings]}: ${hours}`)
        .join(joinChar);
}
